export default function ArticlesArchive () {
  const WRAPPERS = document.querySelectorAll('.mtt-articles-archive')
  if (WRAPPERS.length > 0) {
    for (let i = 0; i < WRAPPERS.length; i++) {
      const WRAPPER = new ArticleWrapper(WRAPPERS[i])
      WRAPPER.init()
    }
  }
}

class ArticleWrapper {
  constructor (WRAPPER) {
    this.WRAPPER = WRAPPER
    this.CATEGORIES = this.WRAPPER.querySelectorAll('.mtt-articles-archive__category')
    this.LOADER = this.WRAPPER.querySelector('.mtt-articles-archive__loader')
    this.TARGET = this.WRAPPER.querySelector('.mtt-articles-archive__target')
    this.PAGINATION_TARGET = this.WRAPPER.querySelector('.mtt-articles-archive__pagination-target')

    this.type = this.WRAPPER.getAttribute('data-type')
    this.url = new URL(window.location.href)
    this.postType = this.WRAPPER.getAttribute('data-post-type')

    this.data = {
      action: this.type !== null ? `filter_articles_${this.type}` : 'filter_articles',
      category: parseInt(this.WRAPPER.getAttribute('data-initial-category')) || 0,
      postType: this.postType,
      pagenumber: 1,
    }
  }

  init () {
    this.categoriesHandler()
    this.paginationHandler()
  }

  categoriesHandler () {
    if (this.CATEGORIES.length > 0) {
      for (let i = 0; i < this.CATEGORIES.length; i++) {
        const CAT = this.CATEGORIES[i]

        CAT.addEventListener('click', () => {
          this.data.category = parseInt(CAT.getAttribute('data-category'))
          this.data.pagenumber = 1
          this.loadPosts()
        })
      }
    }
  }

  paginationHandler () {
    const PAGINATION_TOGGLES = this.WRAPPER.querySelectorAll('.mtt-pagination__toggle')
    if (PAGINATION_TOGGLES.length > 0) {
      for (let i = 0; i < PAGINATION_TOGGLES.length; i++) {
        const TOGGLE = PAGINATION_TOGGLES[i]

        TOGGLE.addEventListener('click', (e) => {
          e.preventDefault()
          this.data.pagenumber = parseInt(TOGGLE.getAttribute('data-page'))
          this.loadPosts()
        })
      }
    }
  }

  setActiveCategory () {
    for (let i = 0; i < this.CATEGORIES.length; i++) {
      const CAT = this.CATEGORIES[i]
      parseInt(CAT.getAttribute('data-category')) === this.data.category
        ? CAT.classList.add('active')
        : CAT.classList.remove('active')
    }
  }

  loadPosts () {
    this.beforeAjax()
    jQuery.post(main_theme_objects.ajax_url, this.data, (response) => {
      if (response !== 0) {
        if (this.TARGET && 'markup' in response) this.TARGET.innerHTML = response.markup
        if (this.PAGINATION_TARGET && 'pagination' in response) this.PAGINATION_TARGET.innerHTML = response.pagination
        this.paginationHandler()
        this.afterAjax()
      }
    })
  }

  beforeAjax () {
    this.showLoader()
    this.setActiveCategory()
  }

  afterAjax () {
    this.hideLoader()
    this.scrollTop()
    this.setUrlParams()
  }

  setUrlParams() {

    if (this.data.category !== 0) {
      this.url.searchParams.set('category', this.data.category)
    } else {
      this.url.searchParams.delete('category')
    }

    if (this.data.pagenumber !== 1) {
      this.url.searchParams.set('pagenumber', this.data.pagenumber)
    } else {
      console.log('hallo')
      this.url.searchParams.delete('pagenumber')
    }

    window.history.replaceState(null, null, this.url)
  }

  showLoader () {
    this.LOADER && this.LOADER.classList.add('loader--show')
  }

  hideLoader () {
    this.LOADER && this.LOADER.classList.remove('loader--show')
  }

  getScrollOffset () {
    let offset = 0
    const HEADER = document.getElementById('main_header')
    offset += HEADER ? HEADER.getBoundingClientRect().height : 0
    const ADMIN_BAR = document.getElementById('wpadminbar')
    offset += ADMIN_BAR ? ADMIN_BAR.getBoundingClientRect().height : 0
    return offset
  }

  scrollTop () {
    jQuery('html, body').animate({
      scrollTop: jQuery(this.WRAPPER).offset().top - this.getScrollOffset()
    }, 700)
  }
}
